import { render, staticRenderFns } from "./ToothSurfaces.vue?vue&type=template&id=00795a60&scoped=true"
import script from "./ToothSurfaces.vue?vue&type=script&lang=js"
export * from "./ToothSurfaces.vue?vue&type=script&lang=js"
import style0 from "./ToothSurfaces.vue?vue&type=style&index=0&id=00795a60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00795a60",
  null
  
)

export default component.exports